<template>
  <v-card class="d-flex pa-4 flex-column" outlined>
    <v-card class="ma-3" outlined elevation="2" style="height: 'min-content'">
      <div
        :style="{ padding: '25px', paddingBottom: '10px', fontSize: 'small' }"
      >
        <v-row>
          <v-col cols="10" sm="4"> Username </v-col>
          <v-col cols="2" sm="1"> : </v-col>
          <v-col cols="12" sm="7">
            {{ data == null ? '' : data.username }}
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="10" sm="4"> MID </v-col>
          <v-col cols="2" sm="1"> : </v-col>
          <v-col cols="12" sm="7">
            {{ data == null ? '' : data.mid }}
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="10" sm="4"> Last Login </v-col>
          <v-col cols="2" sm="1"> : </v-col>
          <v-col cols="12" sm="7">
            {{ data == null ? '' : data.last_login }}
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="10" sm="4"> Created Date </v-col>
          <v-col cols="2" sm="1"> : </v-col>
          <v-col cols="12" sm="7">
            {{ data == null ? '' : data.created_at }}
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="10" sm="4"> Force Change Password </v-col>
          <v-col cols="2" sm="1"> : </v-col>
          <v-col cols="12" sm="7">
            {{ data == null ? '' : data.password_change }}
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="10" sm="4"> Biometric Status </v-col>
          <v-col cols="2" sm="1"> : </v-col>
          <v-col cols="12" sm="7">
            <a
              @click="viewStatus"
              @keydown.enter="viewStatus"
              class="text-decoration-none"
              >View Status</a
            >
          </v-col>
        </v-row>
      </div>

      <v-data-table
        :headers="headers"
        :items="listMerchantUsers"
        :options.sync="options"
        :server-items-length="totalMerchantUsers"
        :loading="loading"
        loading-text="Loading... Please wait"
        :item-class="rowClass"
        class="d-print-table"
        :footer-props="{
          itemsPerPageOptions: [5, 10, 25, 50],
        }"
        sort-by="id"
        :style="{ padding: '10px' }"
        fixed-header
      >
        <template v-slot:[`body.prepend`]>
          <tr>
            <td
              class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row"
            ></td>
            <td
              class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row"
            >
              <v-text-field
                v-model="search.merchant_name"
                type="text"
                label="Merchant Name"
                v-on:keyup.enter="getDetailData"
                hide-details="true"
                dense
                prepend-inner-icon="mdi-magnify"
              ></v-text-field>
            </td>
            <td
              class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row"
            >
              <v-text-field
                v-model="search.mid"
                type="text"
                label="MID"
                v-on:keyup.enter="getDetailData"
                hide-details="true"
                dense
                prepend-inner-icon="mdi-magnify"
              ></v-text-field>
            </td>
            <td
              class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row"
            >
              <v-text-field
                v-model="search.nmid"
                type="text"
                label="NMID"
                v-on:keyup.enter="getDetailData"
                hide-details="true"
                dense
                prepend-inner-icon="mdi-magnify"
              ></v-text-field>
            </td>
            <td
              class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row"
            >
              <v-text-field
                v-model="search.mobile_phone"
                type="text"
                label="No Handphone"
                v-on:keyup.enter="getDetailData"
                hide-details="true"
                dense
                prepend-inner-icon="mdi-magnify"
              ></v-text-field>
            </td>
            <td
              class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row"
            >
              <v-select
                v-model="search.qr_type"
                :items="qrType"
                label="Jenis QR"
                item-text="text"
                item-value="value"
                @change="getDetailData"
                clearable
                hide-details="true"
                dense
              ></v-select>
            </td>
          </tr>
        </template>
        <template v-slot:item="{ item, index }">
          <tr
            :key="index"
            :style="{ cursor: 'pointer' }"
            :class="selectedRow === index ? 'indigo lighten-5' : ''"
            @click="selectRow(index)"
          >
            <td class="d-block d-sm-table-cell d-print-table-cell">
              {{ (options.page - 1) * options.itemsPerPage + index + 1 }}
            </td>
            <td class="d-block d-sm-table-cell d-print-table-cell">
              {{ item.merchant_name }}
            </td>
            <td class="d-block d-sm-table-cell d-print-table-cell">
              {{ item.mid }}
            </td>
            <td class="d-block d-sm-table-cell d-print-table-cell">
              {{ item.nmid }}
            </td>
            <td class="d-block d-sm-table-cell d-print-table-cell">
              {{ item.mobile_phone }}
            </td>
            <td class="d-block d-sm-table-cell d-print-table-cell">
              {{ item.qr_type_name }}
            </td>
          </tr>
        </template>
        <template v-slot:no-data>
          <v-btn
            color="primary"
            @click="clearSearch"
            :disabled="loading"
            :loading="loading"
          >
            Reset
          </v-btn>
        </template>
      </v-data-table>

      <div class="ma-2 text-center">
        <v-btn
          class="ma-1"
          color="warning"
          @click="() => $router.push(backUrl)"
        >
          back
        </v-btn>
      </div>
    </v-card>

    <view-detail-biometric
      :dialog="dialog"
      :id="$route.params.id"
      v-on:closeCancelParent="close"
    />
  </v-card>
</template>

<script>
import { dataQrType } from '../../store/params';
import { text, isEmpty, date } from '../../lib/helpers';

export default {
  components: {
    ViewDetailBiometric: () =>
      import('../../components/form/ViewDetailBiometric.vue'),
  },
  data() {
    return {
      qrType: dataQrType,
      options: {},
      headers: [
        {
          text: 'No',
          align: 'start',
          value: 'id',
          sortable: false,
          width: '10',
        },
        {
          text: 'Nama Merchant',
          value: 'merchant_name',
        },
        {
          text: 'MID',
          value: 'mid',
        },
        {
          text: 'NMID',
          value: 'nmid',
        },
        {
          text: 'No Handphone',
          value: 'mobile_phone',
        },
        {
          text: 'Jenis QR',
          value: 'qr_type',
        },
      ],
      search: {
        merchant_name: '',
        mid: '',
        nmid: '',
        mobile_phone: '',
        qr_type: '',
      },
      selectedRow: '',
      dialog: false,
    };
  },
  watch: {
    options: {
      handler() {
        this.getDetailData();
      },
      deep: true,
    },

    show() {
      if (!this.show) {
        this.search.merchant_name = '';
        this.search.mid = '';
        this.search.nmid = '';
        this.search.mobile_phone = '';
        this.search.qr_type = '';
        this.$nextTick(() => {
          this.getDetailData();
        });
      }
    },
  },
  computed: {
    backUrl() {
      return this.$route.params.type == 'portal'
        ? '/user-management-merchant/portal'
        : '/user-management-merchant/mobile';
    },
    data() {
      return this.$store.state.userMerchant.usersMerchantDetail;
    },
    listMerchantUsers() {
      return this.$store.state.userMerchant.usersMerchant.list;
    },
    totalMerchantUsers() {
      return this.$store.state.userMerchant.totalUsers;
    },
    totalPage() {
      return this.$store.state.userMerchant.totalPage;
    },
    loading() {
      return this.$store.state.userMerchant.loading;
    },
  },
  methods: {
    viewStatus() {
      this.dialog = true;
    },

    close() {
      this.dialog = false;
    },

    selectRow(index) {
      if (this.selectedRow !== index) {
        this.selectedRow = index;
      } else {
        this.selectedRow = '';
      }
    },

    rowClass() {
      const rowClass = 'max-width-col';
      return rowClass;
    },

    clearSearch() {
      this.search.merchant_name = '';
      this.search.mid = '';
      this.search.nmid = '';
      this.search.mobile_phone = '';
      this.search.qr_type = '';
      this.getDetailData();
    },

    async getDetailData() {
      const { page, itemsPerPage, sortBy, sortDesc } = this.options;
      await this.$store
        .dispatch('userMerchant/viewMerchant', {
          id: this.$route.params.id,
          page,
          itemsPerPage,
          sortBy,
          sortDesc,
          search: this.search,
          date,
          type: this.$route.params.type,
        })
        .then(() => {
          if (this.totalPage < page) {
            if (this.totalPage == 0) {
              this.options.page = 1;
            } else {
              this.options.page = this.totalPage;
            }
          }
        });
    },

    back() {
      this.$router.back();
    },

    text,
    isEmpty,
  },
};
</script>

<style>
.max-width-col td {
  white-space: nowrap;
  overflow: hidden;
  max-width: 250px;
  text-overflow: ellipsis;
}
.v-data-table .v-data-table__wrapper {
  height: 100%;
}
</style>
